class Utils {
  isMeta = (ev: KeyboardEvent | MouseEvent): boolean => ev.metaKey || ev.ctrlKey

  benchmark = (num_times: number = 1000, callback: () => void): void => {
    const start = window.performance.now();

    for (let i = 0; i < num_times; i++) {
      callback();
    }

    const end = window.performance.now();
    console.log(`Execution time: ${end - start} ms`);
  }
}

export default new Utils()
